import { ComponentInstall } from "../../utils";
import Pagination from "./src";

export default ComponentInstall(Pagination);
